import { render, staticRenderFns } from "./BuildingNewIcon.vue?vue&type=template&id=7e18f1c6&"
import script from "./BuildingNewIcon.vue?vue&type=script&lang=ts&"
export * from "./BuildingNewIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports